import { GetServerSideProps } from "next";
import { ReactElement } from "react";
import { getPageProps } from "@services/initial-calls";
import TermsAndConditions from "@components/shared/legal/termsAndConditions";
import TalcumClaimsWrapper from "@components/layouts/talcumclaimsWrapper";

export default function TalcumClaimsHome(): ReactElement {
    return (
        <TalcumClaimsWrapper>
            <div className="max-w-7xl mx-auto">
                <TermsAndConditions
                    category="TalcumClaims"
                    domain="TalcumClaims.com"
                />
            </div>
        </TalcumClaimsWrapper>
    );
}

export const getServerSideProps: GetServerSideProps = async (context) => {
    return await getPageProps(context, "home", {
        pageTitle: "Terms And Conditions",
    });
};
